// We have the following vendor prefixing specifically for flexbox to prevent issues when hosted in ancient Tableau Desktop Qt Webkit
// We don't do prefixing generally mostly because we haven't had issues broadly enough to warrant a grander solution
// See TFSID 1030484

import { NestedCSSProperties } from 'typestyle/lib/types';

export const AlignItemsCenter: NestedCSSProperties = {
  '-webkit-align-items': 'center',
  alignItems: 'center',
};

export const JustifyContentCenter: NestedCSSProperties = {
  '-webkit-justify-content': 'center',
  justifyContent: 'center',
};

export const DisplayInlineFlex: NestedCSSProperties = {
  display: ['-webkit-inline-flex', 'inline-flex'],
};

export const DisplayFlex: NestedCSSProperties = {
  display: ['-webkit-flex', 'flex'],
};

export const FlexDirectionColumn: NestedCSSProperties = {
  '-webkit-flex-direction': 'column',
  flexDirection: 'column',
};

export const FlexDirectionColumnReverse: NestedCSSProperties = {
  '-webkit-flex-direction': 'column-reverse',
  flexDirection: 'column-reverse',
};

export const FlexGrow1: NestedCSSProperties = {
  '-webkit-flex-grow': 1,
  flexGrow: 1,
};

export const FlexShrink0: NestedCSSProperties = {
  '-webkit-flex-shrink': 0,
  flexShrink: 0,
};

export const Flex = (value: NestedCSSProperties['flex']): NestedCSSProperties => ({
  '-webkit-flex': value,
  flex: value,
});
